<mat-form-field fxFlex="0 1 100%">
    <input matInput [placeholder]="placeholder" i18n-placeholder [formControl]="articleCodeControl" (blur)="onBlur()" />
</mat-form-field>
<span *ngIf="isDirty">
    <p *ngIf="validArticleCode; else smallLoading">
        <span class="valid" *ngIf="validArticleCode === 1" i18n="@@codeIsValid">Code is valid</span>
        <span class="error" *ngIf="validArticleCode === -1" i18n="@@codeIsTakenPleaseEnterAnotherCode"
            >This code is taken, please enter another code</span
        >
    </p>
</span>
<ng-template #smallLoading>
    <div fxLayout="row" fxLayoutAlign="start center" class="spinner-container mt-2">
        <app-kd-logo-loading size="small"></app-kd-logo-loading>
    </div>
</ng-template>
